import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 768px;
  margin: 0 auto;
`;

export const Card = styled.div`
  margin-top: 16px;
  margin-bottom: 40px;
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0px 1.2px 4px #eaeef1;
`;

export const CardHeader = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid #e6edf2;

  > span {
    font-weight: 900;
    font-size: 16px;
  }
`;

export const CardBody = styled.div`
  padding: 16px;

  > hr {
    height: 1px;
    width: 100%;
    margin: 16px 0;
    display: block;
    border: none;
    background-color: #e6edf2;
  }
`;
export const CardBodyList = styled.div`
  display: flex;
  flex-direction: row;
  @media (max-width: 640px) {
    flex-direction: column;
  }
`;
export const ColumnCard = styled.div`
  @media (min-width: 640px) {
    width: 50%;
  }

  div {
    color: #161d1f;
    font-size: 14px;
    font-weight: 400px;
    padding: 2px;
  }
`;

export const ColumnCard2 = styled.div`
  div {
    color: #161d1f;
    font-size: 14px;
    font-weight: 400px;
    padding: 2px;
  }
`;

export const CardBodyOption = styled.div`
  display: flex;
  justify-content: space-between;

  > div {
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;

    > span:nth-of-type(1) {
      font-weight: 700;
      font-size: 16px;
    }

    > span:nth-of-type(2) {
      font-size: 14px;
    }

    &::after {
      content: '';
      position: absolute;
      right: 0;
      height: 100%;
      width: 1px;
      background-color: #e6edf2;
    }

    &:last-child {
      &::after {
        display: none;
      }
    }
  }

  @media (min-width: 640px) {
    justify-content: flex-start;

    > div {
      width: max-content;
      padding-right: 48px;
      flex-direction: row;
      justify-content: flex-start;
      gap: 8px;

      &::after {
        right: 23px;
      }
    }
  }
`;

export const CardBodySlider = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  > div {
    display: flex;
    justify-content: space-between;

    > span:nth-of-type(1) {
      font-weight: 900;
      font-size: 14px;
    }
  }
`;
